import { createTheme, adaptV4Theme } from '@mui/material/styles';

export const theme = createTheme(adaptV4Theme({
	palette: {
		primary: {
			main: '#4e4ba6'
		},
		secondary: {
			main: '#E5E5E5',
			contrastText: '#4e4ba6'
		},
		white: '#FFFFFF',
	},

	overrides: {
		MuiSlider: {
			rail: {
				backgroundColor: '#03DAC6'
			},
			track: {
				backgroundColor: '#00696B'
			},
			thumb: {
				backgroundColor: '#00696B'
			},
		},
		MuiTab: {
			root: {
				minWidth: 'auto',
				maxWidth: 'auto',
				'@media (min-width: 0px)': {
					minWidth: 'auto',
					maxWidth: 'auto',
				}
			}
		},
		MuiFormControl: {
			root: {
				marginBottom: '20px'
			}
		},
		MuiFilledInput: {
			root: {
				backgroundColor: '#FFFFFF !important',
				borderRadius: '4px 4px 0px 0px',
			},
		},
		MuiInputLabel: {
			shrink: {
				color: '#6202EE'
				// transform: 'translate(20px, -18px) scale(0.75) !important'
			},
		},
		MuiRadio: {
			root: {
				padding: '0'
			}
		}
	},

	config: {
		containerWidth: '1280px',
	}
}))
